export class EmployeeLocalTax {
  LocalTypeId: number;
  TaxCode: string;
  FilingStatus: string;
  WithholdingAllowances: number;
}

export class EmployeeTax {
  IsActive: boolean;
  TaxCode: string;
  FilingStatus: string;
  WithholdingAllowance: number;
  AdditionalAllowances: number;
  AdditionalWithholdingAmount: number;
  AdditionalWithholdingType: string;
  IntegrityHash: string;
  StateAbbreviation: string;
  IsExemptFromWithholding: boolean;
  W4Version: number; // 0: pre-2020, 1: 2020+
  IsHigherWithholding: boolean;
  ChildTaxCredit: number;
  OtherIncome: number;
  WageDeduction: number;
}

export class EmployeeTaxes {
  FedAndState: EmployeeTax[];
  Locals: EmployeeLocalTax[];
  PreviousResidentState: string;
  PreviousWorksInState: string;

  constructor() {
    this.FedAndState = [];
    this.Locals = [];
    this.PreviousResidentState = null;
    this.PreviousWorksInState = null;
  }
}

export class EmployeeTaxExemptions {
  EmployeeStateTaxExemptionsByState: StateTaxExemption[] = [];
  HasSSExemption: boolean;
  HasMEDCExemption: boolean;
  HasSUIExemption: boolean;
  HasFUTAExemption: boolean;
  FUTAExemptionReason: string;
  HasVisa: boolean;
  VisaExpirationDate: Date;
  IntegrityHash: string;
}

export class StateTaxExemption {
  EmployeeTaxExemptionState: string;
  EmployeeStateTaxExemptions: StateTaxExemptions;
}

export class StateTaxExemptions {
  HasDisLeaveExempt?: boolean;
  HasFamilyLeaveExempt?: boolean;
  HasMedLeaveExempt?: boolean;
}
